import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { baseClassNames } from 'components/Selects/BaseSelect/config/baseSelect.config';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import { useCallback, useState } from 'react';
import { joinClasses } from 'utils/componentStyles/style.utils';

// The control wears the classes of the speed buttons beside it, so the playback theme rules
// (dark map UI, contrast themes) style it the same way. The menu keeps the BaseSelect look.
const FRAME_COUNT_SELECT_CLASS_NAMES = {
  ...baseClassNames,
  container: () => 'doppler-frame-count-select',
  control: ({ isDisabled, isFocused }) =>
    joinClasses(
      'btn btn-sm btn-outline-secondary doppler-playback-speed d-flex flex-nowrap align-items-center gap-1 px-2 py-1',
      isFocused && 'doppler-frame-count-focused',
      isDisabled && 'disabled',
    ),
  valueContainer: () => 'p-0',
  input: () => 'm-0 p-0',
  singleValue: () => '',
  indicatorsContainer: () => '',
  dropdownIndicator: () => 'doppler-frame-count-indicator p-0',
  indicatorSeparator: () => 'd-none',
  menu: (state) => joinClasses(baseClassNames.menu(state), 'small'),
};

// react-select keeps a 38 px minimum height even when unstyled; the speed buttons are shorter.
const FRAME_COUNT_SELECT_STYLES = {
  control: (baseStyles) => ({ ...baseStyles, minHeight: 0 }),
  menuPortal: (baseStyles) => ({ ...baseStyles, zIndex: 'var(--z-popover)' }),
};

/** Chooses how many Doppler frames the animation loads and plays. */
export default function DopplerFrameCountSelect({ options, value, onChange, isDisabled = false }) {
  const [menuPortalTarget, setMenuPortalTarget] = useState(null);
  // Use this control's document so the menu also opens in a popped-out widget window.
  const attachContainer = useCallback((node) => {
    setMenuPortalTarget(node?.ownerDocument.body ?? null);
  }, []);

  return (
    <div ref={attachContainer} className="flex-shrink-0">
      <BaseSelect
        useBaseClassNames={false}
        classNames={FRAME_COUNT_SELECT_CLASS_NAMES}
        styles={FRAME_COUNT_SELECT_STYLES}
        isSearchable={false}
        selectProps={{
          'aria-label': 'Doppler animation frames',
          options,
          value: findSelectOption(options, value),
          onChange: (option) => option && onChange?.(option.value),
          isDisabled,
          menuPlacement: 'auto',
          menuPosition: 'fixed',
          menuPortalTarget,
        }}
      />
    </div>
  );
}
